import { html } from "lit-html";
import { AddRecommendationItemJsEnv, RecommendationItemFoldersAPI } from "../../models/add_recommendation_item_js_env";
import { AccordionC } from "../accordion";
import { Button } from "../button";
import { visible } from "../warning";

// 推奨品追加モーダル
export const AddRecommendationItemBody = (model: AddRecommendationItemJsEnv) => {
  if(model.recommendationItemFoldersApiResult == RecommendationItemFoldersAPI.NO_FOLDERS) {
    return AddRecommendationItemNoFolders();
  } else if(model.recommendationItemFoldersApiResult == RecommendationItemFoldersAPI.ERROR) {
    return AddRecommendationItemError(model);
  } else {
    return AddRecommendationItemNormal(model);
  }
}

// 推奨品フォルダ一覧取得API：正常 or 「選択したフォルダに登録」ボタン押下でAPIエラー
export const AddRecommendationItemNormal = (model: AddRecommendationItemJsEnv) => html`
  <div class="a-heading -typeh5 u-mb-24">
    <h2 class="a-heading_text">推奨品に登録</h2>
  </div>
  ${model.warningMessage ? visible(model.warningMessage) : html``}
  <div class="o-colBox -jcbetween u-mb-16">
    <p class="a-text u-mb-16">商品を登録するフォルダを選択してください</p>
  </div>
  <div class="o-addfolderlist js-addfolderlist">
    <div class="o-addfolderlist_listwrapper">
      <ul class="o-addfolderlist_list">
        <li class="o-addfolderlist_accordion js-accordion is-open">
          ${AccordionC(model)}
        </li>
      </ul>
    </div>
    <ul class="a-list -noDot u-mb-32">
      <li class="a-listitem">企業推奨品管理の画面にてフォルダの並び替え・削除・名称変更・新規作成などをした場合、反映にお時間を要する場合があります。</li>
    </ul>
    <div class="o-colBox -jccenter -margin8">
      ${Button()}
    </div>
  </div>
`;

// 推奨品フォルダ一覧取得API：推奨品フォルダ0件
export const AddRecommendationItemNoFolders = () => html`
    <div class="a-heading -typeh5 u-mb-24">
      <h2 class="a-heading_text">推奨品に登録</h2>
    </div>
    <div class="o-addfolderlist js-addfolderlist">
      <div class="o-addfolderlist_listwrapper">
        <p class="a-text u-mb-16">フォルダがありません</p>
      </div>
      <ul class="a-list -noDot u-mb-32">
        <li class="a-listitem">フォルダのご登録がない場合は企業推奨品管理の画面からフォルダを追加したのち、しばらくしてから再度ご登録ください。</li>
        <li class="a-listitem">企業推奨品管理の画面にてフォルダの並び替え・削除・名称変更・新規作成などをした場合、反映にお時間を要する場合があります。</li>
      </ul>
      <div class="o-colBox -jccenter -margin8">
        ${Button()}
      </div>
    </div>
`;

// 推奨品フォルダ一覧取得API：推奨品フォルダ0件以外のAPIエラー
export const AddRecommendationItemError = (model: AddRecommendationItemJsEnv) => html`
    <div class="a-heading -typeh5 u-mb-24">
      <h2 class="a-heading_text">推奨品に登録</h2>
    </div>
    ${visible(model.warningMessage)}
    <div class="o-addfolderlist js-addfolderlist">
      <ul class="a-list -noDot u-mb-32">
        <li class="a-listitem">企業推奨品管理の画面にてフォルダの並び替え・削除・名称変更・新規作成などをした場合、反映にお時間を要する場合があります。</li>
      </ul>
      <div class="o-colBox -jccenter -margin8">
        ${Button()}
      </div>
    </div>
  `;
